import React from 'react'
import classes from '../Navbar.module.scss'
import {
  Label
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'

type Props = {
  icon?: React.ReactElement<React.ComponentProps<typeof KanBoIcon>>
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const NavbarLabel: React.FC<Props> = ({
  children,
  icon,
  onClick,
  className,
  ...restProps
}) => {
  let compClassName = classes.navbarLabel
  if (children) compClassName += ' ' + classes.withChildren
  if (onClick) compClassName += ' ' + classes.hover
  if (className) compClassName += ' ' + className

  return (
    <Label
      {...restProps}
      className={compClassName}
      onClick={onClick}
    >
      {icon &&
        React.cloneElement(icon, {
          className: icon.props.className ? icon.props.className + ' ' + classes.navbarLabelIcon : classes.navbarLabelIcon
        })
      }
      {children &&
        <span className={classes.navbarLabelChildren}>
          {children}
        </span>
      }
    </Label>
  )
}

export default NavbarLabel
